import axios from 'axios'
import Configure from '@/utils/configure'

class Session {
  constructor() {
    this.prefix = `${Configure.project}:`
  }

  getSecret() {
    const apiKey = localStorage.getItem(`${this.prefix}api-key`)
    return (apiKey !== null || apiKey !== '') ? apiKey : null
  }

  setSecret(apiKey) {
    axios.defaults.headers.common.Authorization = apiKey
    localStorage.setItem(`${this.prefix}api-key`, apiKey)
  }

  destroy() {
    localStorage.removeItem(`${this.prefix}api-key`)
  }
}

export default new Session()